import { Menu, Col, Spin, Row, Input } from "antd";
import moment from "moment";
import { useState, useEffect } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { ReactComponent as TimerIcon } from "shared/assets/images/timer-icon.svg";
import { ReactComponent as QuincyIcon } from "shared/assets/images/quincy-icon.svg";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ReactComponent as SearchIcon } from "shared/assets/images/icon-search.svg";
import { ReactComponent as IconClose } from "shared/assets/images/icon-close.svg";
import { ReactComponent as EditIcon } from "shared/assets/images/edit-icon.svg";
interface ChatHistoryMenuProps {
  menuItems: any[];
  chatIdSelected: string | null;
  onClickMenuItem: (info: any) => Promise<void>;
  onClickNewChat: () => Promise<void>;
  loading: boolean;
  hide: boolean;
  onClose: () => void;
}

const ChatHistoryMenu: React.FC<ChatHistoryMenuProps> = ({
  menuItems,
  chatIdSelected,
  onClickMenuItem,
  loading,
  hide,
  onClose,
  onClickNewChat,
}) => {
  const { t } = useTranslation();
  const [groupedItems, setGroupedItems] = useState({
    today: [],
    yesterday: [],
    lastWeek: [],
    older: [],
  });
  const [search, setSearch] = useState<string>("");
  useEffect(() => {
    const grouped = menuItems.reduce(
      (acc, item) => {
        const itemDate = moment(item.createdOn);
        const today = moment();
        const yesterday = moment().subtract(1, "days");

        if (itemDate.isSame(today, "day")) {
          acc.today.push(item);
        } else if (itemDate.isSame(yesterday, "day")) {
          acc.yesterday.push(item);
        } else if (itemDate.isAfter(today.subtract(7, "days"))) {
          acc.lastWeek.push(item);
        } else {
          acc.older.push(item);
        }
        return acc;
      },
      { today: [], yesterday: [], lastWeek: [], older: [] }
    );

    setGroupedItems(grouped);
  }, [menuItems]);

  const renderMenu = (items: any[]) => (
    <Menu
      mode="inline"
      theme="dark"
      items={items}
      className="menu-chats"
      inlineIndent={0}
      onClick={onClickMenuItem}
      selectedKeys={[chatIdSelected ?? ""]}
    />
  );

  const renderLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 40 }} spin={false} />}
        />
      </div>
    );
  };

  const renderChats = () => {
    const filter = (items: any[]) => {
      return items.filter(
        (x: any) =>
          x.label?.toLowerCase().includes(search?.toLowerCase()) || !search
      );
    };

    return (
      <Col xs={24} className="wrapper">
        {groupedItems.today.length > 0 && (
          <>
            <p className="group-chats">{t("pages.Quincy.today")}</p>
            {renderMenu(filter(groupedItems.today))}
          </>
        )}

        {groupedItems.yesterday.length > 0 && (
          <>
            <p className="group-chats">{t("pages.Quincy.yesterday")}</p>
            {renderMenu(filter(groupedItems.yesterday))}
          </>
        )}

        {groupedItems.lastWeek.length > 0 && (
          <>
            <p className="group-chats">{t("pages.Quincy.lastWeek")}</p>
            {renderMenu(filter(groupedItems.lastWeek))}
          </>
        )}

        {groupedItems.older.length > 0 && (
          <>
            <p className="group-chats">{t("pages.Quincy.olderMessages")}</p>
            {renderMenu(filter(groupedItems.older))}
          </>
        )}
      </Col>
    );
  };
  const isOpen = isMobile ? hide : true;

  return (
    <div
      className={`history-chat ${isMobile && "mobile"}`}
      style={{
        display: isOpen ? "block" : "none",
      }}
    >
      <IconClose
        className={`close-history ${isMobile && "mobile"}`}
        onClick={onClose}
      />
      <Row className="container-chats scroll-style">
        <Col className="header" xs={24}>
          <h1 className="title">
            <QuincyIcon width={21} className="fill-only" />
            {t("pages.Quincy.quincy")}
          </h1>
          <h3 className="subtitle">{t("pages.Quincy.title")}</h3>
        </Col>
        {isMobile && (
          <Col xs={24}>
            <span className="btn-new-chat mobile" onClick={onClickNewChat}>
              <EditIcon />
              {t("pages.Quincy.newChat")}
            </span>
            <Input
              placeholder={t("pages.Quincy.search")}
              className="search-input"
              suffix={<SearchIcon />}
              onChange={(x) => setSearch(x.target.value)}
            />
          </Col>
        )}
        <Col xs={24}>
          <p className="title-history-chat">
            <TimerIcon /> {t("pages.Quincy.history")}
          </p>
        </Col>
        {!isMobile && (
          <Col>
            <span className="btn-new-chat" onClick={onClickNewChat}>
              <EditIcon />
              {t("pages.Quincy.newChat")}
            </span>
          </Col>
        )}
        {loading ? renderLoading() : renderChats()}
      </Row>
    </div>
  );
};

export default ChatHistoryMenu;
